import "./styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";

const appRoot = document.querySelector<HTMLElement>("#app");

if (appRoot === null) {
  throw new Error("Missing application root");
}

createRoot(appRoot).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
